const SpinningLoader = () => {
  return <div className="spinning-loader"></div>
}

export default SpinningLoader
